<template>
    <!-- a row that scrolls sideways: a swipe on a touch screen; with a mouse, arrows next to the title -->
    <div class="scroll-strip">
        <div class="scroll-strip__head">
            <div class="scroll-strip__title">
                <slot name="title" />
            </div>
            <!-- only when the row does not fit; an arrow fades when there is nothing more that way -->
            <div v-if="hasMouse && !$vuetify.breakpoint.xs && (canLeft || canRight)" class="scroll-strip__nav">
                <button type="button" class="scroll-strip__arrow" :disabled="!canLeft" aria-label="Προηγούμενα" @click="scroll(-1)">
                    <v-icon small>mdi-chevron-left</v-icon>
                </button>
                <button type="button" class="scroll-strip__arrow" :disabled="!canRight" aria-label="Επόμενα" @click="scroll(1)">
                    <v-icon small>mdi-chevron-right</v-icon>
                </button>
            </div>
        </div>
        <div ref="track" class="scroll-strip__track" :style="{ gap: `${gap}px` }" @scroll.passive="update">
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ScrollStrip',
        props: {
            gap: {
                type: Number,
                default: 16
            }
        },
        data() {
            return {
                canLeft: false,
                canRight: false,
                observer: null,
                // a mouse: arrows; touch screens and phone widths swipe
                hasMouse: typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)').matches : true
            }
        },
        mounted() {
            window.addEventListener('resize', this.update, { passive: true })
            // the cards arrive or change size after the first paint
            if (window.ResizeObserver) {
                this.observer = new ResizeObserver(() => this.update())
                this.observer.observe(this.$refs.track)
            }
            this.$nextTick(this.update)
        },
        updated() {
            this.$nextTick(this.update)
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.update)
            if (this.observer) this.observer.disconnect()
        },
        methods: {
            update() {
                const el = this.$refs.track
                if (!el) return
                this.canLeft = el.scrollLeft > 4
                this.canRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 4
            },
            scroll(direction) {
                const el = this.$refs.track
                if (el) {
                    el.scrollBy({ left: direction * Math.max(el.clientWidth * 0.8, 260), behavior: 'smooth' })
                }
            }
        }
    }
</script>

<style scoped>
.scroll-strip__head {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 14px;
}

.scroll-strip__title {
    flex: 1 1 auto;
    min-width: 0;
}

/* the heading keeps its look, the space under it is the row's */
.scroll-strip__title > * {
    margin-bottom: 0 !important;
}

.scroll-strip__nav {
    display: flex;
    flex: 0 0 auto;
    gap: 6px;
}

.scroll-strip__arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: #0d0d0f;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
    transition: background 0.15s, opacity 0.15s;
}

/* the dark of the site, a white arrow */
.scroll-strip__arrow .v-icon {
    color: #fff !important;
}

.scroll-strip__arrow:hover:not(:disabled) {
    background: linear-gradient(90deg, #ef4444 0%, #ff7133 50%, orange 100%);
}

.scroll-strip__arrow:hover:not(:disabled) .v-icon {
    color: #fff !important;
}

.scroll-strip__arrow:disabled {
    opacity: 0.3;
    cursor: default;
}

.scroll-strip__track {
    display: flex;
    padding: 4px 2px 14px;
    overflow-x: auto;
    scroll-snap-type: x proximity;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.scroll-strip__track::-webkit-scrollbar {
    display: none;
}

.scroll-strip__track > * {
    scroll-snap-align: start;
}
</style>
